export default "__VITE_ASSET__252162a1__"